const Settings = {
  arrows: false,
  dots: true,
};

export default Settings;



// WEBPACK FOOTER //
// ./src/screens/Landing/SlickSettings.js